import React from "react";
import Background, { BackgroundType } from "../components/Background";
import { createUseStyles } from "react-jss";
import DisplayText, { TextVariant } from "../components/DisplayText";
var useStyles = createUseStyles({
    root: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 8px"
    },
    container: {
        marginTop: 16,
        display: "flex",
        flexDirection: "column",
        padding: 16
    },
});
var UserLimitPage = function () {
    var classes = useStyles();
    return (React.createElement(Background, { type: BackgroundType.Welcome },
        React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.container },
                React.createElement(DisplayText, { variant: TextVariant.title, color: "#FFF", component: "p" }, "Sorry!")),
            React.createElement("div", { className: classes.container },
                React.createElement(DisplayText, { variant: TextVariant.s34reg, color: "#FFF", align: "center", lineHeight: 1.25 }, "We've reached full capacity, please stay tuned to InsideSAS for the next Social Innovation event!")))));
};
export default UserLimitPage;
//# sourceMappingURL=userlimit.js.map